import { HasFiscalPrinter } from '@pos/app/scripts/services/has-fiscal-printer';
import { PosState } from '@pos/app/scripts/services/pos-state';

/*
 * Service isFiscalSale
 */
angular
  .module('posApp')
  .factory(
    'isFiscalSale',
    (posState: PosState, hasFiscalPrinter: HasFiscalPrinter) => {
      const isFiscalSale = () => {
        if (hasFiscalPrinter() && !posState.returnTransaction) {
          return true;
        }

        return false;
      };

      return isFiscalSale;
    },
  );
